<template>
  <div class="no-next-period-box full-height">
    <Grid
      v-if="subscription.one_time_purchase"
      content-items="center"
      place-items="center"
      class="text-heading-1 text-secondary-1 full-height"
    >
      No renewal possible
    </Grid>

    <template v-else>
      <FormSubscriptionPeriod
        v-if="showCreateDialog"
        :subscription-period="period"
        :original-tasks="originalTasks"
        :subscription-id="subscription.id"
        :showing="showCreateDialog"
        :disable-properties="period ? ['product_id'] : []"
        @refresh="refreshSubscription"
        @close="showCreateDialog = false"
      />

      <div class="text-heading-5 text-secondary-1 text-uppercase">New period?</div>
      <LineSeparator horizontal />

      <Grid gaf="column" justify-content="center" align-items="center" class="full-height" gap="var(--r-space-sm)">
        <RBtn
          v-for="(action, key, index) in actions"
          :key="action.label"
          :type="index === 0 ? 'tertiary' : 'primary'"
          size="small"
          @click="updateSubscription(key)"
        >
          {{ action.label }}
        </RBtn>
      </Grid>
    </template>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
import { event } from '@/plugins/event-bus'
// Libraries
import { mapGetters, mapMutations } from 'vuex'
import { cloneDeep } from 'lodash'
// Components
import FormSubscriptionPeriod from '@components/forms/form-subscription-period/FormSubscriptionPeriod'
import LineSeparator from '@/modules/show-page-subscription/components/LineSeparator'

export default {
  components: {
    FormSubscriptionPeriod,
    LineSeparator
  },

  data: () => ({
    showCreateDialog: false,
    originalTasks: null
  }),

  computed: {
    ...mapGetters('subscription-show', ['subscription']),

    actions() {
      return this.subscription.current.actions
    },

    period() {
      const subscription = cloneDeep(this.subscription)
      let period = cloneDeep(subscription.current)
      period.product = subscription.product
      return period
    }
  },

  methods: {
    ...mapMutations('subscription-show', ['setSubscription', 'setPeriodId']),

    async updateSubscription(action) {
      if (action === 'create_new_period') {
        apiTo
          .GET_TASK_APPLICABILITY_FOR_SUB(this.subscription.id)
          .then(({ data }) => (this.originalTasks = data.result.task_applicability))
        this.showCreateDialog = true
      } else {
        action = { [action]: true }
        const periodId = this.subscription.current.id
        await apiTo.MODIFY_SUBSCRIPTION_PERIOD(periodId, action)
        this.refreshSubscription()
      }
    },

    refreshSubscription() {
      apiTo.GET_SUBSCRIPTION(this.subscription.id).then(({ data }) => {
        const periodId = data.result.next ? data.result.next.id : data.result.current.id

        this.setSubscription(data.result)
        this.setPeriodId(periodId)

        event.$emit('refetchSubscriptionPeriods')
        this.$root.$emit('refresh-milestones-data', {
          periodId: periodId,
          milestone: null
        })
      })
    }
  }
}
</script>
